import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { productShortName, systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="border-y border-lava/30 bg-petrol py-16 sm:py-20" aria-labelledby="system-title" data-id="element-256" data-mp="36kbo76pcz0os">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-257" data-mp="31kz06imr3nkm">
        <span className="inline-flex items-center gap-2 rounded-full bg-lava px-4 py-2 text-xs font-extrabold uppercase tracking-[.12em] text-carbon" data-id="element-258" data-mp="31mjymjc6rqnr">
          <AwardIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-259" data-mp="2stgk07pt17rj" /> The Most Comprehensive Geothermal Energy
          Teaching System in the World
        </span>
        <SectionHeading id="system-title" className="mt-6" data-id="element-260" data-mp="2ity3k193s448">
          {productShortName}
        </SectionHeading>
        <p className="mt-4 font-semibold text-muted" data-id="element-261" data-mp="2dumocwodx6or">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses · Everything you need to teach geothermal energy with
          confidence.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-262" data-mp="18qzr7suxd8ka">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-white/10 bg-carbon/70 p-4 text-sm font-semibold text-muted" data-id="element-263" data-mp="u2v66i8egkyc">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-lava" aria-hidden="true" data-id="element-264" data-mp="1cr04ha6afdpr" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-2xl border border-lava/60 bg-carbon p-6 text-left text-lg font-bold leading-relaxed text-snow shadow-lg shadow-black/40" data-id="element-265" data-mp="1bv103yc1b53">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-energy" aria-hidden="true" data-id="element-266" data-mp="28ymnp6szej64" />
          It's a complete system so you can enter the classroom with confidence and deliver lessons that truly teach how
          geothermal energy works, why renewable energy matters, and how geothermal technology contributes to sustainable
          energy solutions while maintaining environmental and economic responsibility.
        </p>
      </div>
    </section>;
}